export default {
    props: {
        formTitle: String,
        comment: String,
        presetModel: String,
        presetAreaCode: String,
        presetName: String,
        campaignCode: String,
        welfareId: [String, Number],
        privacyList: {
            type: Array,
            default: () => [{ text: '《蔚来汽车隐私条款》', linkTo: '/privacy' }]
        },
        privacyName: {
            type: String,
            default: '《蔚来汽车隐私条款》'
        },
        privacyLink: {
            type: String,
            default: '/privacy'
        },
        privacyAgreed: {
            type: Boolean,
            default: false
        },
        customStyle: String,
        submitButtonStyle: String,
        submitButtonText: {
            type: String,
            value: '一键预约'
        },
        fields: {
            type: Array,
            value: []
        },
        formMode: {
            type: String,
            value: 'leads'
        },
        defaultFormStatus: {
            type: Number,
            value: 0
        },
        askingModal: {
            type: Object,
            value: {
                enabled: false,
                title: '体验试驾',
                content: '邀您体验试驾',
                cancelText: '取消',
                confirmText: '确定'
            }
        },
        series: {
            type: Array,
            value: []
        },
        trackName: String,
        isDemo: Boolean,
        backgroundImg: String,
        bizType: String,
        guideLink: String,
        presetChannel: {
            // potal端设置的 是否涟漪邀请
            type: String,
            value: 'INVITATION_PAGE'
        },
        componentId: [String, Number],
        positionRank: [String, Number],
        useGeoLocation: {
            type: Boolean,
            value: false
        },
        lpConfig: Object,
        rootMark: String
    }
};



// WEBPACK FOOTER //
// ./src/views/marketing/mixin/form-props.js